import {
    Typography } from "../../ui";
import React from "react";
import SnpButton from "../../global/SnpButton";
import DismissButton from "../../global/DismissButton";
import DialogBox from "../../global/DialogBox";
import {
  CART_INITIAL_STATE,
  getDeviceTypeNew
} from "../../../constants/constant";
import { useSelector } from "react-redux";
import { handleInvoicePrint } from "../../../utilities/printUtils";
import { set } from "lodash";
import { useDeviceType } from "../../global/hooks/useDeviceType";

const CustomerCopyBill = ({
  showDialog,
  billNo,
  printDetails,
  setShowDialog,
}) => {

  const { billDetails } = useSelector((state) => state.bill);
    const storeApiUrl = useSelector(
      (state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL
    );
    const storeActiveShopHash = useSelector(
      (state) => state.setActiveShopHashReducer.activeShopHash
    );

    const {isMobile, isTablet} = useDeviceType(getDeviceTypeNew);
  const renderCustCopyContent = () => {
    return (
      <>
        <Typography
          variant="subtitle4"
          component="div"
          style={{ color: "#2f1160" }}
        >
          Do You Want to Print Customer Copy
        </Typography>
      </>
    );
  };

      const renderCustCopyActions = () => {
        return (
          <>
            <SnpButton
              variant="contained"
              color="primary"
              onClick={() => {
               // raiseInvoiceClicked(printDetails.custPrint, "cust"); // if we are clicking this it means we want the print right? custPrint should be true? what if its false we should not call this method?
                handleInvoicePrint({
                           printRef: printDetails.custPrint,
                           name: "cust",
                           apiToken: CART_INITIAL_STATE.apiToken,
                           shopId: storeActiveShopHash.id,
                           billNo: billDetails.billNo,
                           backendBaseUrl: storeApiUrl.BACKEND_BASE_URL,
                           printOptions: { isMobile: isMobile || isTablet },
                           //setShowCustCopyDialog, // optional
                         });
               setShowDialog(false);          
               // fetchBill(listbillingData.billNo, null);
              }}
            >
              Yes
            </SnpButton>
            <DismissButton
              variant="contained"
              color="primary"
              onClick={() => {
                setShowDialog(false);
                //fetchBill(listbillingData.billNo, null);
              }}
            >
              No
            </DismissButton>
          </>
        );
      };
  return (
    <div>
      <DialogBox
        showDialog={showDialog}
        title="Alert!"
        onClose={() => {
          setShowDialog(false);
         // fetchBill(listbillingData.billNo, null);
        }}
        dialogContent={renderCustCopyContent()}
        dialogActions={renderCustCopyActions()}
      ></DialogBox>
    </div>
  );
};

export default CustomerCopyBill;
